export default "__VITE_ASSET__BM00pkwL__"